export interface ITextInputContextMenu {
  show(event: PointerEvent): void;
}

export function instanceOfITextInputContextMenu(instance: any): instance is ITextInputContextMenu {
  return instance
    && (instance.show !== undefined);
}
